import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-white/60 font-heading uppercase tracking-widest text-sm animate-pulse">
          Loading…
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
};

export default ProtectedRoute;
